import type { IntegrationsTranslator } from '../integrations-translator'
import type { InboundEventCategory } from './types'

/**
 * Every category a provider's event catalog groups its events by, with its
 * key in the `integrations` catalog (`events.categories`). A provider
 * catalog names its categories in English (`InboundEventCategory.label`);
 * the integration page shows them in the reader's language.
 */
const EVENT_CATEGORY_KEY = {
  user: 'user',
  organization: 'organization',
  organization_membership: 'organizationMembership',
  member: 'member',
  authentication: 'authentication',
  directory_sync: 'directorySync',
  connection: 'connection',
  invitation: 'invitation',
  billing: 'billing',
  waitlist: 'waitlist',
  purchase: 'purchase',
  subscription: 'subscription',
  customer: 'customer',
  order: 'order',
  checkout: 'checkout',
  fulfillment: 'fulfillment',
  invoice: 'invoice',
  quote: 'quote',
  payment: 'payment',
  forms: 'forms',
} as const

type EventCategoryId = keyof typeof EVENT_CATEGORY_KEY

export function isKnownEventCategory(id: string): id is EventCategoryId {
  return Object.hasOwn(EVENT_CATEGORY_KEY, id)
}

/** A category's heading in the reader's language; an unknown one keeps its catalog English. */
export function eventCategoryLabel(
  t: IntegrationsTranslator,
  category: Pick<InboundEventCategory, 'id' | 'label'>
): string {
  return isKnownEventCategory(category.id)
    ? t(`events.categories.${EVENT_CATEGORY_KEY[category.id]}`)
    : category.label
}
